// extracted by mini-css-extract-plugin
module.exports = {"infoBox":"InfoBox_infoBox__e9com","infoBoxLabel":"InfoBox_infoBoxLabel__TZ6dd","importantLabel":"InfoBox_importantLabel__sxQ_5","infoBoxContent":"InfoBox_infoBoxContent__k2ge0"};